import { useRef, useState , useEffect } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";

import back from "../../back.png";
import InputDownloader from "../../helpers/InputDownloader";
import MediaLink from "../../helpers/MediaLink";


function Zoom(props)
{

    const [row,setRow] = useState(props.row) ;

    const onBack = (e) => {
        props.goBack();
    }



    return <div className="view_content">

                <img src={back} onClick={onBack} className="back_img" title="wstecz"/>


                <h1><PlTitle userData={props.userData} /> / Wiadomości wysłane / {row.tytul}</h1>


                <div className="bg_center">
                    
                        <div className="x_review">
                                  <div className="x_row">
                                               <b>Od:</b> {row.nadawca.nazwa}
                                  </div>

                                  <div className="x_row">
                                        <b> Do:</b>  {row.odbiorca.nazwa}
                                  </div>

                                  <div className="x_row">
                                        {row.czas}
                                  </div>

                                  <div className="x_row_white">                                            
                                           
                                               <div dangerouslySetInnerHTML={{__html: row.tresc}} />
                                  </div>

                                    {
                                        row.zalczniki.length > 0 &&
                                        <div className="x_row">
                                                <b> Załączniki:</b>  
                                                {
                                                    row.zalczniki.map( (z, zi)  => {
                                                        return <MediaLink userData={props.userData} mainView={props.mainView} title={z.nazwa} link={ Config.url + "/api,image,secure," + z.api_unique} />                                                       
                                                    } )
                                                }
                                        </div>
                                    }

                        </div>

                </div>

    </div>
}



export default Zoom;